import {
  isCompletedFact,
  buildWidget,
  getBottomComponentHtml,
} from './table-view';

require('./fact-widget.component.scss');

function str2ab(str) {
  const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  const bufView = new Uint16Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

export function FactsWidgetComponent($compile) {
  return {
    restrict: 'E',
    scope: {
      model: '<',
      filter: '<',
      fact: '<',
      openImage: '<',
      listType: '<',
    },
    controller: function(
      $scope,
      $element,
      LocalStorageService,
      FilterResource,
      CurrentFilterDataService,
      $q,
    ) {
      $scope.FilterResource = FilterResource;
      $scope.CurrentFilterDataService = CurrentFilterDataService;
      $scope.isCollapsed = $scope.listType === 'full';
      $scope.$q = $q;
      $scope.loading = true;


      $scope.collapse = function() {
        $scope.isCollapsed = !$scope.isCollapsed;
        if ($scope.isCollapsed) {
          $element.addClass('collapsed');
        } else {
          if (!isCompletedFact($scope.fact)) {
            $scope.loading = true;
            if ($scope.CurrentFilterDataService.loadingFact && $scope.CurrentFilterDataService.loadingFact.loading) {
              $scope.CurrentFilterDataService.loadingFact.canceller.resolve();
              if ($scope.CurrentFilterDataService.loadingFact.scope) {
                $scope.CurrentFilterDataService.loadingFact.scope.loading = false;
              }
            } else {
              $scope.CurrentFilterDataService.loadingFact = {
                loading: true,
              };
            }
            const canceller = $scope.$q.defer();
            $scope.CurrentFilterDataService.loadingFact.scope = $scope;
            $scope.CurrentFilterDataService.loadingFact.canceller = canceller;

            $scope.FilterResource.getCompleteFact($scope.filter, $scope.fact.id, canceller)
              .then(data => {
                if (data && $scope.fact.id == data.id) {
                  Object.assign($scope.fact, data);
                  const widget = buildWidget($scope.fact);
                  $element.html(widget);
                  $compile($element.contents())($scope);
                }
                $scope.loading = false;
              }, e => {
                // if e.status == -1  request canselled;
                if (e.status !== -1)
                  console.error(e);
              });
          }
          $element.removeClass('collapsed');
        }
      };
      $scope.collapse();

      $scope.copyToClippboard = (e, text) => {
        e.stopPropagation();
        if (!text) {
          const text = e.target.closest('.widget-value').innerText;
        }
        LocalStorageService.copyTextToClipboard(text);
      };

    },
    link: function(scope, element, attrs) {
      if (!scope.openImage) {
        scope.openImage = () => {};
      }
      scope.loading = false;
      const widget = '<sc-spinner ng-if="loading" style="z-index: 999;"></sc-spinner>' + buildWidget(scope.fact);
      element.append(widget);
      $compile(element.contents())(scope);
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-widget.component.js